import { Typography } from "@mui/material";

function NoDataMessage() {
  return (
    <Typography sx={{ fontStyle: "italic", ml: 3 }}>
      Your Carrier does not send this data.
    </Typography>
  );
}

export default NoDataMessage;
